<template>
  <footer>
    <div class="footer-container w">
      <div class="f-left">
        <svg-icon icon-class="icon_logo_footer" class-name="f-logo"></svg-icon>
        <p class="f-tel">Tel：0755 - 2811 5311</p>
        <p class="f-email">E-mail：service@houkeyun.com</p>
        <p class="f-address">地址: 深圳市南山数字文化产业基地西塔楼1007</p>
        <img class="f-qr" src="~@/assets/imgs/qr_weChat.png" alt />
        <p>关注公众号</p>
        <p class="f-name">厚科云健康科技有限公司 © | 厚科云</p>
        <p class="f-copy">
          <a href="https://beian.miit.gov.cn" target="view_window"
            >粤ICP备15112511号-1</a
          >
          powered by Houkeyun
        </p>
      </div>
      <div class="f-right">
        <dl class="f-dl">
          <dt>解决方案</dt>
          <dd><router-link to="/solve">八大健康管理</router-link></dd>
          <dd><router-link to="/solve">三大慢病管理</router-link></dd>
        </dl>

        <dl class="f-dl">
          <dt>客户服务</dt>
          <dd><router-link to="/service">建立慢病管理流程</router-link></dd>
          <dd><router-link to="/service">部署慢病管理系统</router-link></dd>
          <dd><router-link to="/service">进行ERP系统的对接</router-link></dd>
          <dd><router-link to="/service">商品及促销方案的导入</router-link></dd>
        </dl>

        <dl class="f-dl">
          <dt>客户案例</dt>
          <dd>
            <router-link :to="{ path: 'detail', query: { id: 0 } }"
              >云南健之佳健康药房</router-link
            >
          </dd>
          <dd>
            <router-link :to="{ path: 'detail', query: { id: 1 } }"
              >杭州九洲大药房</router-link
            >
          </dd>
          <dd>
            <router-link :to="{ path: 'detail', query: { id: 2 } }"
              >海棠药堂</router-link
            >
          </dd>
          <dd>
            <router-link :to="{ path: 'detail', query: { id: 3 } }"
              >康美药业</router-link
            >
          </dd>
        </dl>

        <dl class="f-dl">
          <dt>关于我们</dt>
          <dd><router-link to="/about">公司概述</router-link></dd>
          <dd><router-link to="/about">核心技术</router-link></dd>
          <dd><router-link to="/about">主营业务</router-link></dd>
        </dl>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" scoped>
$color: #aeafb1;
footer {
  width: 100%;
  background: #1b1f23;
  .footer-container {
    height: 412px;
    padding: 26px 0;
    @include clearfix;
    .f-left {
      width: 350px;
      float: left;
      font-size: 15px;
      font-weight: 400;
      color: $color;
      line-height: 21px;
      .f-logo {
        width: 189px;
        height: 40px;
        margin-bottom: 28px;
      }
      .f-qr {
        width: 145px;
        height: 145px;
        margin: 10px 0;
      }
      .f-copy {
        a {
          color: $color;
        }
      }
    }
    .f-right {
      float: right;
      width: 700px;
      padding: 26px 0;
      @include clearfix;
      .f-dl {
        width: 175px;
        float: left;
        font-weight: 400;
        dt {
          font-size: 20px;
          color: #fff;
          line-height: 28px;
          padding-bottom: 9px;
          border-bottom: 1px solid #fff;
        }
        dd {
          font-size: 16px;
          line-height: 22px;
          margin-top: 14px;
          color: $color;
          a {
            color: $color;
          }
        }
      }
      .f-dl:first-child {
        dd {
          font-size: 20px;
        }
      }
    }
  }
}
</style>